<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="80px" inline size="mini">
      <el-form-item label="商家模式">
        <el-select v-model="query.businessType" placeholder="请选择商家模式" clearable>
          <el-option label="无人" value="1"></el-option>
          <el-option label="滴滴" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商家信息">
        <el-input v-model="query.merchant" clearable placeholder="请输入商家信息"></el-input>
      </el-form-item>
      <el-form-item label="代理信息">
        <el-input v-model="query.agent" clearable placeholder="请输入代理信息"></el-input>
      </el-form-item>
      <el-form-item label="员工信息">
        <el-input v-model="query.staff" clearable placeholder="请输入员工信息"></el-input>
      </el-form-item>
      <el-form-item label="美团团购">
        <el-select v-model="query.openMeituan" clearable placeholder="请选择美团团购">
          <el-option label="关闭" value="0"></el-option>
          <el-option label="开启" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="首页状态">
        <el-select v-model="query.display" placeholder="请选择首页状态">
          <el-option label="显示" value="1"></el-option>
          <el-option label="隐藏" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否删除">
        <el-select v-model="query.isDeleted" placeholder="请选择是否删除">
          <el-option label="已删除" value="1"></el-option>
          <el-option label="未删除" value="0"></el-option>
        </el-select>
      </el-form-item>
      <!-- 创建时间 -->
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="period"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-button class="resetBtn" type="warning" size="mini" @click="custody">重置</el-button> -->
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <el-button type="success" size="mini" @click="excelMerchantDetail">明细导出</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card class="box-card">
      <!-- 数据展示区域 -->
      <el-table :data="merchantList" style="width: 100%" height="650px" stripe border :cell-style="cellStyle" :header-cell-style="cellStyle">
        <!-- 展开行区域 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="110px" label-position="left" inline class="expand">
              <el-form-item label="商家标识:">
                <span>{{ scope.row.uuid }}</span>
              </el-form-item>
              <el-form-item label="运营电话:">
                <span>{{ scope.row.businessPhone }}</span>
              </el-form-item>
              <el-form-item label="运营时间:">
                <span>{{ scope.row.businessHours }}</span>
              </el-form-item>
              <el-form-item label="入驻时间:">
                <span>{{ scope.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="店铺地址:">
                <span>{{ scope.row.address }}</span>
              </el-form-item>
              <el-form-item label="">
                <span></span>
              </el-form-item>
              <el-form-item label="背景图片:">
                <el-image style="width: 100%; height: 75px" :src="scope.row.backgroundImage.split(';')[0]" :preview-src-list="scope.row.backgroundImage.split(';')"></el-image>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商家名" width="180"></el-table-column>
        <el-table-column label="模式" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.businessType === 1" type="warning">无人</el-tag>
            <el-tag v-if="scope.row.businessType === 2" type="danger">滴滴</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="contactor" label="联系人" width="90">
          <template slot-scope="scope">
            <div class="numberingBox" @click="editNickname(scope.row, scope.$index)">
              <i class="el-icon-edit-outline"></i>
              {{scope.row.contactor}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="cellphone" label="手机号码" width="100"></el-table-column>
        <el-table-column prop="profitRate" label="分润比例" width="80" align="right">
          <template slot-scope="scope">{{scope.row.profitRate}} %</template>
        </el-table-column>
        <el-table-column prop="meituanProfitRate" label="美团分润" width="100" align="right">
          <template slot-scope="scope">
            {{scope.row.meituanProfitRate}} %
            <el-tooltip v-if="scope.row.openMeituanProfit === 0" effect="dark" content="点击开启美团分佣" placement="bottom-start">
              <el-button type="success" icon="el-icon-s-finance" size="mini" circle @click="toggleProfitSwitch(scope.row, scope.$index, 88)"></el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.openMeituanProfit === 1" effect="dark" content="点击关闭美团分佣" placement="bottom-start">
              <el-button type="danger" icon="el-icon-switch-button" size="mini" circle @click="toggleProfitSwitch(scope.row, scope.$index, 88)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="douyinProfitRate" label="抖音分润" width="100" align="right">
          <template slot-scope="scope">
            {{scope.row.douyinProfitRate}} %
            <el-tooltip v-if="scope.row.openDouyinProfit === 0" effect="dark" content="点击开启抖音分佣" placement="bottom-start">
              <el-button type="success" icon="el-icon-s-finance" size="mini" circle @click="toggleProfitSwitch(scope.row, scope.$index, 99)"></el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.openDouyinProfit === 1" effect="dark" content="点击关闭抖音分佣" placement="bottom-start">
              <el-button type="danger" icon="el-icon-switch-button" size="mini" circle @click="toggleProfitSwitch(scope.row, scope.$index, 99)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="profitRate" label="商店分润" width="80" align="right">
          <template slot-scope="scope">{{scope.row.shopProfitRate}} %</template>
        </el-table-column>
        <el-table-column prop="totalProfit" align="right" label="钱包收益/元" width="100">
          <template slot-scope="scope">
            <div class="numberingBox" @click="openWallet(scope.row)">
              {{scope.row.totalProfit}}
              <i class="el-icon-coin"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="unusedProfit" align="right" label="钱包余额/元" width="100"></el-table-column>
        <!-- <el-table-column prop="createTime" label="入驻时间" width="150"></el-table-column> -->
        <el-table-column prop="agentName" label="代理名称"  width="120"></el-table-column>
        <el-table-column prop="agentCellphone" label="代理号码" width="100"></el-table-column>
        <el-table-column prop="staffName" label="员工名称"></el-table-column>
        <el-table-column prop="staffCellphone" label="员工号码" width="100"></el-table-column>
        <el-table-column label="首页" width="70">
          <template slot-scope="scope">
            <div class="numberingBox" @click="display(scope.row, scope.$index)">
              <el-tag type="" v-if="scope.row.display === 1">显示</el-tag>
              <el-tag type="info" v-else>隐藏</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推广" width="70">
          <template slot-scope="scope">
            <div class="numberingBox" @click="promote(scope.row, scope.$index)">
              <el-tag type="" v-if="scope.row.businessPromote === 1">开启</el-tag>
              <el-tag type="info" v-else>关闭</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="openMeituan" label="美团" width="70">
          <template slot-scope="scope">
<!--            <el-tag type="warning" v-if="scope.row.openMeituan === 1">开启</el-tag>-->
            <el-tag type="warning" v-if="scope.row.openMeituan === 2">开启|预订</el-tag>
            <el-tag type="info" v-if="scope.row.openMeituan === 0">关闭</el-tag>
            <el-tooltip v-if="scope.row.openMeituan === 1" effect="dark" content="美团团购已开启，点击开启【预定】同步订单功能" placement="bottom-start">
              <el-button type="primary" icon="el-icon-s-goods" size="mini" @click="openMeituanBook(scope.row, scope.$index)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="openDouyin" label="抖音" width="70">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.openDouyin === 1">开启</el-tag>
            <el-tag type="info" v-if="scope.row.openDouyin === 0">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="旗舰店" width="70">
          <template slot-scope="scope">
            <div class="numberingBox" @click="flagship(scope.row, scope.$index)">
              <el-tag type="warning" v-if="scope.row.type !== 1">否</el-tag>
              <el-tag type="info" v-else>是</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商家预定" width="80">
          <template slot-scope="scope">
            <div class="numberingBox" @click="openBook(scope.row, scope.$index)">
              <el-tag type="warning" v-if="scope.row.openMerchantBooking === 1">开启</el-tag>
              <el-tag type="info" v-else>关闭</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收单机构" width="100">
          <template slot-scope="scope">
            <div class="numberingBox" @click="changeAcquirer(scope.row, scope.$index)">
              <el-tag type="warning" v-if="scope.row.acquirer === 1">微信财付通</el-tag>
              <el-tag type="warning" v-else-if="scope.row.acquirer === 8">美团内嵌</el-tag>
              <el-tag type="primary" v-else>连连支付</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="修改手机号码" placement="bottom-start">
              <el-button type="primary" :disabled="scope.row.isDeleted===1" icon="el-icon-phone" size="mini" @click="editCellphone(scope.row.contactorUuid, scope.row.isDeleted)"></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="商家分润记录" placement="bottom-start">
              <el-button type="info" :disabled="scope.row.isDeleted===1" icon="el-icon-edit" size="mini" @click="editProfit(scope.row.uuid,scope.row.isProfit, scope.row.isDeleted)"></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="商家小程序码" placement="bottom-start">
              <el-button type="warning" :disabled="scope.row.isDeleted===1" icon="el-icon-share" size="mini" @click="downloadBarcode(scope.row.uuid)"></el-button>
            </el-tooltip>
            <!-- <el-tooltip effect="dark" content="商家详情" placement="bottom-start">
              <el-button type="success" :disabled="scope.row.isDeleted===1?true:false" icon="el-icon-s-custom" size="mini" @click="lookInfo(scope.row.uuid, scope.row.isDeleted)"></el-button>
            </el-tooltip> -->
            <!-- <el-tooltip effect="dark" content="重新定位" placement="bottom-start">
              <el-button type="warning" :disabled="scope.row.isDeleted===1?true:false" icon="el-icon-location" size="mini" @click="setPosition(scope.row, scope.$index)"></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 商家详情信息对话框 -->
    <el-dialog title="商家详情" :visible.sync="merInfoDialogVisible" width="50%">
      <div class="mer-dt">
        <el-form label-position="left" label-width="120px" inline>
          <el-form-item label="商家ID :">
            <span>{{ merchantDetails.uuid }}</span>
          </el-form-item>
          <el-form-item label="商家名称 :">
            <span>{{ merchantDetails.name }}</span>
          </el-form-item>
          <el-form-item label="联系姓名 :">
            <span>{{ merchantDetails.contactor }}</span>
          </el-form-item>
          <el-form-item label="联系号码 :">
            <span>{{ merchantDetails.cellphone }}</span>
          </el-form-item>
          <!-- <el-form-item label="运营类型 :">
            <span>{{ merchantDetails.businessType }}</span>
          </el-form-item> -->
          <el-form-item label="运营电话 :">
            <span>{{ merchantDetails.businessPhone }}</span>
          </el-form-item>
          <el-form-item label="运营时间 :">
            <span>{{ merchantDetails.businessHours }}</span>
          </el-form-item>
          <el-form-item label="分润比例 :">
            <span>{{ merchantDetails.profitRate }} %</span>
          </el-form-item>
          <el-form-item label="店铺地址 :">
            <span>{{ merchantDetails.address }}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 调整商家分润对话框 -->
    <el-dialog title="商家分润记录" :visible.sync="profitDialogVisible" width="50%">
      <div>
        <el-form ref="profitRateRef" :model="profitRateForm" :rules="profitRateRules" label-width="150px" class="profitRateForm">
          <el-form-item label="商店商品分润比例" prop="profitRate">
            <el-input v-model="profitRateForm.shopProfitRate" type="number" placeholder="最高为100"></el-input>
          </el-form-item>
        </el-form>

        <el-table :data="profitRecording" style="width: 100%" border stripe>
          <el-table-column prop="createTime" label="变更时间"></el-table-column>
            <el-table-column label="变更前分润(%)">
              <template slot-scope="scope">{{scope.row.beforeInfo*100}}</template>
            </el-table-column>
            <el-table-column label="变更后分润(%)">
                <template slot-scope="scope">{{scope.row.afterInfo*100}}</template>
            </el-table-column>
          <!-- <el-table-column prop="remark" label="备注"></el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="profitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProfitSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改手机号码对话框 -->
    <el-dialog title="修改手机号码" :visible.sync="mdCellphoneDialogVisible" @close="close('mdCellphoneRef')" width="30%">
      <div class="modify">
        <!-- 修改手机号码表单 -->
        <el-form ref="mdCellphoneRef" v-if="isDel == 0" :model="mdCellphoneForm" :rules="mdCellphoneRules" label-width="80px">
          <el-form-item label="手机号码" prop="cellphone">
            <el-input v-model="mdCellphoneForm.cellphone" placeholder="请输入更改的手机号码" maxlength="11" clearable></el-input>
          </el-form-item>
        </el-form>
        <!-- 手机号码历史记录 -->
        <el-table :data="cellphoneList" style="width: 100%" stripe border="">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="createTime" label="变更时间"></el-table-column>
          <el-table-column prop="beforeInfo" label="变更前号码"></el-table-column>
          <el-table-column prop="afterInfo" label="变更后后号码"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mdCellphoneDialogVisible = false">取 消</el-button>
        <el-button type="primary" v-if="isDel == 0" @click="editCellphoneBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="重新定位 (Esc 退出)" :visible.sync="mdPositionDialogVisible" fullscreen width="100%">
      <div class="amap">
        <!-- 高德地图 -->
        <div class="amapBox" id="container"></div>
        <!-- 定位按鈕 -->
        <div class="pantoBox"></div>
        <!-- 修改商家地址区域 -->
        <div class="subBox">
          <div>
            <h3>原地址:</h3>
            <p>{{ merchantTemp.address }}</p>
            <p v-if="merchantTemp.longitude !== 0 || merchantTemp.latitude !== 0">经纬度: {{ merchantTemp.longitude }}, {{ merchantTemp.latitude }}</p>
          </div>
          <div style="color: orangered;">
            <h3>新地址:</h3>
            <p>{{ merchant.address }}</p>
            <p v-if="merchant.longitude !== 0 || merchant.latitude !== 0">经纬度: {{ merchant.longitude }}, {{ merchant.latitude }}</p>
          </div>
          <div class="subBtn">
            <button v-if="merchant.longitude !== 0 || merchant.latitude !== 0" @click="submitAddress">确定更改商家地址</button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="商家钱包 (Esc 退出)" :visible.sync="walletDialogVisible" fullscreen>
      <div class="wallet">
        <el-row :gutter="60">
          <el-col :span="9">
            <div class="topBox">
              <div>
                <el-form label-position="left" label-width="100px" inline class="expand">
                  <el-form-item label="是否已认证:">
                    <span v-if="wallet.isAuth === 1">是</span>
                    <span v-else>否</span>
                    <el-button style="margin-left: 20px;" type="warning" size="mini" @click="editAuth()">认证记录</el-button>
                  </el-form-item>
                  <el-form-item label="是否可提现:">
                    <span v-if="wallet.canWithdraw === 1">是</span>
                    <span v-else>否</span>
                    <el-button style="margin-left: 20px;" type="danger" size="mini" @click="editWithdraw()">修改提现状态</el-button>
                  </el-form-item>

                  <el-form-item label="历史总收益:">
                    <span>{{wallet.totalMoney}}元</span>
                  </el-form-item>
                  <el-form-item label="可提现金额:">
                    <span>{{wallet.unusedMoney}}元</span>
                  </el-form-item>
                  <el-form-item label="已提现金额:">
                    <span>{{wallet.usedMoney}}元</span>
                  </el-form-item>
                  <el-form-item label="拉卡拉账户:">
                    <span>{{wallet.lakalaAccount}}</span>
                    <el-button v-if="!wallet.lakalaAccount" type="primary" size="mini" @click="addLakalaAccount()">绑定账户</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <!-- 名下商家收益数据 -->
              <div>
                <p>名下商家收益表</p>
                <el-table :data="mWallet" style="width: 100%" highlight-current-row stripe border="">
                <!-- @current-change="currentChange" -->
                  <!-- <el-table-column type="index"></el-table-column> -->
                  <el-table-column prop="uuid" label="商家标识" width="160"></el-table-column>
                  <el-table-column prop="name" label="商家名称"></el-table-column>
                  <el-table-column prop="totalProfit" label="营收(元)" width="160"></el-table-column>
                  <el-table-column prop="isDeleted" label="状态" width="80">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.isDeleted === 1">关闭</el-tag>
                      <el-tag type="success" v-else>正常</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 折线图区域 -->
            <div class="bottom">
              <p>商家周收益</p>
              <div class="charts" ref="charts" id="charts"></div>
            </div>
          </el-col>
          <!-- 右边区域 -->
          <el-col :span="15">
            <!-- 卡片视图区域 -->
            <el-card>
              <!-- 搜索表单区域 -->
              <el-form :model="queryIncome" label-width="90px" inline size="mini">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="periodIncome"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
                <!-- <el-button class="resetBtn" type="warning" size="mini" @click="custody">重置</el-button> -->
                <el-button type="primary" size="mini" @click="searchIncome">搜索</el-button>
                <el-button type="success" size="mini" @click="excelDetail">明细导出</el-button>
              </el-form>
              <!-- 表格数据展示区域 -->
              <el-table :data="incomeList" style="width: 100%" height="650px" border="" stripe>
                <!-- 展开行区域 -->
                <el-table-column type="expand">
                  <template slot-scope="scope">
                    <el-form label-width="90px" label-position="left" class="expand">
                      <el-form-item label="商户标识">
                        <span>{{ scope.row.sourceUuid }}</span>
                      </el-form-item>
                      <el-form-item label="钱包标识">
                        <span>{{ scope.row.walletUuid }}</span>
                      </el-form-item>
                      <el-form-item label="租凭订单号">
                        <span>{{ scope.row.leaseOrderUuid }}</span>
                      </el-form-item>
                      <el-form-item label="支付订单号">
                        <span>{{ scope.row.payOrderUuid }}</span>
                      </el-form-item>
                      <el-form-item label="备注">
                        <span>{{ scope.row.remark }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <!-- 表格数据展示区域 -->
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="uuid" label="流水号" width="235"></el-table-column>
                <el-table-column prop="amount" label="流水金额(元)"></el-table-column>
                <el-table-column prop="lastAmount" label="钱包余额(元)"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="port" label="出入账">
                  <template slot-scope="scope">
                    <span v-if="scope.row.port === 1">
                      入账
                      <span v-if="scope.row.channel === '1'">（微信）</span>
                      <span v-else-if="scope.row.channel === '21'">（余额）</span>
                      <span v-else-if="scope.row.channel === '66'">（优惠券）</span>
                      <span v-else-if="scope.row.channel === '88'">（美团）</span>
                      <span v-else-if="scope.row.channel === '99'">（抖音）</span>
                    </span>
                    <span v-else-if="scope.row.port === -1">出账</span>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type === 3">收益扣款</span>
                    <span v-else-if="scope.row.type === 4">使用收益</span>
                    <span v-else-if="scope.row.type === 5">收益提现</span>
                    <span v-else-if="scope.row.type === 15">提现回退</span>
                    <span v-else-if="scope.row.type === 31">转账</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页区域 -->
              <el-pagination
                @size-change="pageSizeChangeIncome"
                @current-change="CurrentPageChangeIncome"
                :current-page="queryIncome.curPage"
                :page-sizes="[5, 10, 15]"
                :page-size="queryIncome.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSizeIncome"
              ></el-pagination>
            </el-card>
          </el-col>
        </el-row>
        <!-- 认证状态对话框 -->
        <el-dialog title="认证状态信息" :visible.sync="authDialogVisible" width="70%" append-to-body>
          <div>
            <el-table :data="authList" style="width: 100%" border="" stripe>
              <el-table-column prop="uuid" label="">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.uuid===wallet.authUuid">当前认证</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="cardNo" label="身份证号码"></el-table-column>
              <!-- <el-table-column prop="bankAccountNo" label="银行卡号码"></el-table-column> -->
              <el-table-column prop="bankPreCellphone" label="预留手机号"></el-table-column>
              <el-table-column label="认证状态" width="80">
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.status===1">成功</el-tag>
                  <el-tag type="info" v-else>失败</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="认证时间"></el-table-column>
              <el-table-column label="操作" width="100" v-if="wallet.isAuth===0">
                <template slot-scope="scope">
                  <el-button type="warning" size="mini" @click="authConfirm(scope.row.uuid)">确认认证</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" :disabled="wallet.isAuth === 0" class="authBtn" @click="authCancel">解除认证</el-button>
            <el-button type="primary" @click="authDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
      </div>
    </el-dialog>

</div>
</template>

<script>
import {
  list,
  merchantInfo,
  profit,
  profitList,
  cellphone,
  cellphoneList,
  position,
  wallet,
  week,
  statement,
  excel,
  cancelCredit,
  creditList,
  withdraw,
  confirmCredit,
  contactor,
  modifyPromote,
  modifyDisplay,
  barcode,
  modifyFlagship, excelMerchant, modifyBook, bindLakalaAccount, modifyMeituanBook, modifyProfitSwitch, modifyAcquirer
} from '@/API/merchant'
// import Qrcode from 'qrcode'
import echarts from 'echarts'
import AMap from 'postcss'
// import { baseQR } from '@/base.js'
export default {
  name: 'merchant',
  data() {
    return {
      // 二维码url地址
      qrCodeUrl: '',
      query: {
        curPage: 1,
        pageSize: 10,
        merchantUuid: '',
        name: '',
        contactor: '',
        cellphone: '',
        agentName: '',
        agentCellphone: '',
        type: '',
        isDeleted: '0',
        ctEnd: '',
        ctStart: '',
        merchant: '',
        agent: ''
      },
      isDel: 0,
      // 时间段
      period: [],
      // 商家数据列表
      merchantList: [],
      // 数据总条数
      total: 0,
      //   商家详情对话框
      merInfoDialogVisible: false,
      //   商家详情数据
      merchantDetails: {},
      // 商家分润对话框
      profitDialogVisible: false,
      // 商家分润调整记录
      profitRecording: [],
      profitRange: [],
      // 调整商家分润请求参数
      profitRateForm: {
        merchantUuid: '',
        profitRate: '',
        shopProfitRate: ''
      },
      profitRateRules: {
        shopProfitRate: [{ required: true, message: '请输入分润比例', trigger: 'blur' }]
      },
      // 修改地址地图对话框
      addressDialogVisible: false,
      // 商家店铺地址信息
      addressInfo: {},
      // 修改手机号码对话框是否显示
      mdCellphoneDialogVisible: false,
      // 修改手机号码表单数据
      mdCellphoneForm: {
        cellphone: '', // 手机号码
        contactorUuid: '' // 代理标识
      },
      mdCellphoneRules: {
        cellphone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }]
      },
      // 修改手机号码历史记录
      cellphoneList: [],
      merchantIdx: -1,
      merchant: {
        merchantUuid: '',
        longitude: '',
        latitude: '',
        address: ''
      },
      merchantTemp: {
        merchantUuid: '',
        longitude: '',
        latitude: '',
        address: ''
      },
      mdPositionDialogVisible: false,

      walletDialogVisible: false,
      authDialogVisible: false,
      authList: [],
      walletUuid: '',
      wallet: {
        merchantUuid: '',
        authUuid: '',
        isAuth: 0,
        canWithdraw: 0,
        totalMoney: 0,
        usedMoney: 0,
        unusedMoney: 0
      },
      mWallet: [],
      periodIncome: [],
      queryIncome: {
        walletUuid: '',
        sourceType: '21',
        curPage: 1,
        pageSize: 10,
        ctStart: '',
        ctEnd: ''
      },
      // 收益明细
      incomeList: [],
      totalSizeIncome: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // ecarts配置数据
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          name: '日期',
          nameTextStyle: {
            fontWeight: 700,
            fontSize: 18
          },
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: '收益(元)',
          nameTextStyle: {
            fontWeight: 700,
            fontSize: 18
          },
          type: 'value'
        },
        series: [
          {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: 'red' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: 'blue' // 100% 处的颜色
                }
              ],
              global: false // 缺省为 false
            },
            data: [],
            type: 'line',
            areaStyle: {}
          }
        ]
      }
    }
  },
  created() {
    this.getMerchantList()
  },
  methods: {
    //   获取商家列表数据
    async getMerchantList() {
      const { data: res } = await list(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.merchantList = res.data.entities
      this.total = res.data.totalSize
    },
    // 监听pageSize的变化
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getMerchantList()
    },
    // 监听当前页码值的变化
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getMerchantList()
    },
    // 搜索按钮点击触发
    seach() {
      this.query.curPage = 1
      if (this.period != null && this.period.length > 0) {
        this.query.ctStart = this.period[0]
        this.query.ctEnd = this.period[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      this.getMerchantList()
    },
    // 重置按钮点击触发
    custody() {
      this.period = []
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.getMerchantList()
    },
    // 商家详情信息
    async lookInfo(merchantID, isDel) {
      this.isDel = isDel
      const { data: res } = await merchantInfo({ merchantUuid: merchantID })
      if (res.code !== 200) return this.$message.error(res.message)
      this.merchantDetails = res.data
      this.merInfoDialogVisible = true
    },
    // 获取分润调整记录
    async getProfitRecording(uuid) {
      const { data: res } = await profitList({ merchantUuid: uuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.profitRecording = res.data
    },
    // 调整商家分润
    editProfit(uuid, isProfit, isDel) {
      this.isDel = isDel
      this.profitRecording = []
      this.profitRange = []
      this.profitRateForm.merchantUuid = uuid
      this.getProfitRecording(uuid)
      this.profitDialogVisible = true
    },
    // 调整商家分润提交
    async editProfitSubmit() {
      this.$refs.profitRateRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await profit(this.profitRateForm)
        if (res.code === 200) {
          this.$message.success(res.message)
          if (this.isDel === 0) { this.$refs.profitRateRef.resetFields() }
          this.profitDialogVisible = false
          this.getMerchantList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 修改地址按钮点击触发
    editAddress(uuid, longitude, latitude, address) {
      this.$router.push({
        path: '/amap',
        query: {
          merchantUuid: uuid,
          longitude,
          latitude,
          address
        }
      })
    },
    // 修改手机号码
    editCellphone(uuid, isDel) {
      this.isDel = isDel
      this.cellphoneList = []
      this.mdCellphoneForm.contactorUuid = uuid
      this.getCellphonerec(uuid)
      this.mdCellphoneDialogVisible = true
    },
    close(formRef) {
      if (this.isDel === 0) { this.$refs[formRef].resetFields() }
    },
    // 获取手机号码记录
    async getCellphonerec(uuid) {
      const { data: res } = await cellphoneList({ merchantUuid: uuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.cellphoneList = res.data
    },
    // 修改手机号码
    async editCellphoneBtn() {
      this.$refs.mdCellphoneRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await cellphone(this.mdCellphoneForm)
        if (res.code === 200) {
          this.$message.success(res.message)
          if (this.isDel === 0) { this.$refs.mdCellphoneRef.resetFields() }
          this.mdCellphoneDialogVisible = false
          this.getMerchantList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    setPosition(row, idx) {
      this.fullscreenLoading = true
      this.merchantIdx = idx
      this.merchant = {
        merchantUuid: row.uuid,
        longitude: row.longitude,
        latitude: row.latitude,
        address: row.address
      }
      this.merchantTemp = {
        merchantUuid: row.uuid,
        longitude: row.longitude,
        latitude: row.latitude,
        address: row.address
      }
      this.mdPositionDialogVisible = true
      this.$nextTick(() => {
        this.initAmap()
      })
    },
    initAmap() {
      let that = this
      // 创建地图
      let map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 15,
        center: [that.merchant.longitude, that.merchant.latitude]
      })
      // 中心点标记
      let marker = new AMap.Marker({
        position: [that.merchant.longitude, that.merchant.latitude]
      })
      marker.setMap(map)
      marker.setAnimation('AMAP_ANIMATION_DROP')
      // 地图点击事件
      map.on('click', function(e) {
        that.merchant.longitude = e.lnglat.getLng()
        that.merchant.latitude = e.lnglat.getLat()
        marker.setPosition([that.merchant.longitude, that.merchant.latitude])
        // 逆地理转码功能
        AMap.plugin('AMap.Geocoder', function() {
          var geocoder = new AMap.Geocoder()
          geocoder.getAddress(e.lnglat, function(status, result) {
            if (status === 'complete' && result.regeocode) {
              that.merchant.address = result.regeocode.formattedAddress
            } else {
              // eslint-disable-next-line no-undef
              log.error('地理编码失败,请重试')
            }
          })
        })
      })
      // 定位按钮
      AMap.event.addDomListener(document.querySelector('.pantoBox'), 'click', function() {
        map.panTo([that.merchantTemp.longitude, that.merchantTemp.latitude])
        marker.setPosition([that.merchantTemp.longitude, that.merchantTemp.latitude])
        that.merchant = {
          merchantUuid: that.merchantTemp.uuid,
          longitude: that.merchantTemp.longitude,
          latitude: that.merchantTemp.latitude,
          address: that.merchantTemp.address
        }
      })
    },
    // 修改商家地址
    async submitAddress() {
      const { data: res } = await position({
        merchantUuid: this.merchant.merchantUuid,
        longitude: this.merchant.longitude,
        latitude: this.merchant.latitude,
        address: this.merchant.address
      })
      if (res.code !== 200) return this.$message.error(res.message)
      this.$message.success(res.message)
      this.merchantList[this.merchantIdx].longitude = this.merchant.longitude
      this.merchantList[this.merchantIdx].latitude = this.merchant.latitude
      this.merchantList[this.merchantIdx].address = this.merchant.address
      this.mdPositionDialogVisible = false
    },

    // 进入钱包
    async openWallet(row) {
      this.authList = []
      this.periodIncome = []
      this.incomeList = []
      this.totalSizeIncome = 0
      this.walletUuid = row.walletUuid
      this.queryIncome.walletUuid = row.walletUuid

      this.getWalletInfo()

      this.walletDialogVisible = true
      // 获取代理周收益数据
      const { data: res } = await week({
        walletUuid: this.walletUuid
      })
      if (res.code !== 200) return this.$message.error(res.message)
      this.option.xAxis.data = res.data.weekProfit.map(item => {
        return item.dateStr
      })
      this.option.series[0].data = res.data.weekProfit.map(item => {
        return item.profit
      })

      let charts = this.$refs.charts
      let myChart = echarts.init(charts)
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.option)
    },
    async getAuth() {
      const { data: res } = await creditList({ walletUuid: this.walletUuid })
      if (res.code !== 200) return this.$message.error(res.message)
      this.authList = res.data
    },
    authConfirm(creditUuid) {
      this.$confirm('此操作将确认认证, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await confirmCredit({
          walletUuid: this.walletUuid,
          creditUuid: creditUuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.isAuth = 1
        this.wallet.authUuid = creditUuid
      })
    },
    authCancel() {
      this.$confirm('此操作将解除认证, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await cancelCredit({ walletUuid: this.walletUuid })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.isAuth = 0
        this.wallet.authUuid = ''
      })
    },
    editAuth() {
      this.getAuth()
      this.authDialogVisible = true
    },
    editWithdraw() {
      this.$confirm('此操作将更改是否可提现, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await withdraw({
          canWithdraw: !this.wallet.canWithdraw + 0,
          walletUuid: this.walletUuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.canWithdraw = !this.wallet.canWithdraw + 0
      })
    },
    addLakalaAccount() {
      this.$prompt('此操作将绑定拉卡拉分账账户,请认真确认,是否继续?', '绑定拉卡拉分账账户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '输入不能为空',
        inputType: 'text'
      }).then(async ({ value }) => {
        console.log(value)
        const { data: res } = await bindLakalaAccount({
          accountNo: value,
          accountType: '6666',
          walletUuid: this.walletUuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.wallet.lakalaAccount = value
      })
    },
    // 获取代理钱包信息
    async getWalletInfo() {
      const { data: res } = await wallet({
        walletUuid: this.walletUuid
      })
      if (res.code !== 200) return this.$message.error(res.message)
      this.wallet = res.data.wallet
      this.mWallet = res.data.mWallet
      // this.getIncomeList()
    },
    async queryIncomeList() {
      const { data: res } = await statement(this.queryIncome)
      if (res.code !== 200) return this.$message.error(res.message)
      this.incomeList = res.data.entities
      this.totalSizeIncome = res.data.totalSize
    },
    searchIncome() {
      this.queryIncome.curPage = 1
      if (this.periodIncome != null && this.periodIncome.length > 0) {
        this.queryIncome.ctStart = this.periodIncome[0]
        this.queryIncome.ctEnd = this.periodIncome[1]
      } else {
        this.queryIncome.ctStart = ''
        this.queryIncome.ctEnd = ''
      }
      this.queryIncomeList()
    },
    // 重置按钮点击触发
    custodyIncome() {
      this.period = []
      this.queryIncome = {
        walletUuid: this.walletUuid,
        sourceType: '21',
        curPage: 1,
        pageSize: 10
      }
      this.queryIncomeList()
    },
    // 监听pageSize的变化
    pageSizeChangeIncome(newSize) {
      this.queryIncome.pageSize = newSize
      this.queryIncomeList()
    },
    // 监听当前页码值的变化
    CurrentPageChangeIncome(newPage) {
      this.queryIncome.curPage = newPage
      this.queryIncomeList()
    },
    // 明细导出
    async excelDetail() {
      if (this.periodIncome.length === 0) return this.$message.error('请选择导出的收益明细日期')
      const { data: res } = await excel(this.queryIncome).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '商家收益明细-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    editNickname(row, idx) {
      this.$prompt('', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入联系人',
        inputValue: row.contactor,
        inputPattern: /.+/,
        inputErrorMessage: '联系人格式不正确'
      }).then(async ({ value }) => {
        const { data: res } = await contactor({
          contactorUuid: row.contactorUuid,
          nickname: value
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].contactor = value
      }).catch(() => {
      })
    },
    promote(row, idx) {
      let rk = '关闭'
      if (row.businessPromote === 0) rk = '开启'
      this.$confirm('此操作将' + rk + '首页推广, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await modifyPromote({
          merchantUuid: row.uuid,
          promote: row.businessPromote === 0 ? 1 : 0
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].businessPromote = row.businessPromote === 0 ? 1 : 0
      })
    },
    display(row, idx) {
      let rk = '隐藏'
      if (row.display === 0) rk = '显示'
      this.$confirm('此操作将' + rk + '首页, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await modifyDisplay({
          merchantUuid: row.uuid,
          display: row.display === 0 ? 1 : 0
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].display = row.display === 0 ? 1 : 0
      })
    },
    flagship(row, idx) {
      let rk = '隐藏'
      if (row.type === 2) rk = '显示'
      this.$confirm('此操作将' + rk + '首页【旗舰店】标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await modifyFlagship({
          merchantUuid: row.uuid,
          type: row.type === 1 ? 2 : 1
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].type = row.type === 1 ? 2 : 1
      })
    },
    openBook(row, idx) {
      let rk = '关闭'
      if (row.openMerchantBooking === 0) rk = '开启'
      this.$confirm('此操作将' + rk + '商家0元预定订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await modifyBook({
          merchantUuid: row.uuid,
          booking: row.openMerchantBooking === 0 ? 1 : 0
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].openMerchantBooking = row.openMerchantBooking === 0 ? 1 : 0
      })
    },
    openMeituanBook(row, idx) {
      let rk = '关闭'
      if (row.openMeituan === 1) rk = '开启'
      this.$confirm('此操作将' + rk + '商家美团预定功能,并且向美团同步订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await modifyMeituanBook({
          merchantUuid: row.uuid,
          openMeituan: row.openMeituan === 1 ? 2 : 1
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].openMeituan = row.openMeituan === 1 ? 2 : 1
      })
    },
    /**
     * 切换美团，抖音分润开关
     * @param row
     * @param idx
     * @param type 88美团 99抖音
     */
    toggleProfitSwitch(row, idx, type) {
      let rk = '关闭'
      if (type === 88) {
        if (row.openMeituanProfit === 0) {
          rk = '开启'
        }
        this.$confirm('此操作将' + rk + '美团分润功能, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { data: res } = await modifyProfitSwitch({
            merchantUuid: row.uuid,
            openMeituanProfit: row.openMeituanProfit === 1 ? 0 : 1
          })
          if (res.code !== 200) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.merchantList[idx].openMeituanProfit = row.openMeituanProfit === 1 ? 0 : 1
        })
      } else if (type === 99) {
        if (row.openDouyinProfit === 0) {
          rk = '开启'
        }
        this.$confirm('此操作将' + rk + '美团分润功能, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { data: res } = await modifyProfitSwitch({
            merchantUuid: row.uuid,
            openDouyinProfit: row.openDouyinProfit === 1 ? 0 : 1
          })
          if (res.code !== 200) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.merchantList[idx].openDouyinProfit = row.openDouyinProfit === 1 ? 0 : 1
        })
      }
    },
    changeAcquirer(row, idx) {
      let acquirer = row.acquirer === 1 ? 8 : 1
      let rk = '美团内嵌'
      if (acquirer === 1) {
        rk = '微信财付通'
      }
      this.$confirm('此操作将切换收单机构为：' + rk + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await modifyAcquirer({
          contactorUuid: row.contactorUuid,
          acquirer: acquirer
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        this.merchantList[idx].acquirer = acquirer
      })
    },
    downloadBarcode(uuid) {
      this.$confirm('此操作会下载小程序码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await barcode({
          merchantUuid: uuid
        })
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        window.open(res.data.imageUrl, '_blank')
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 10 || columnIndex === 11 || columnIndex === 8 || columnIndex === 9) {
        return 'background: #f0f9eb;'
      }
      if (row.isDeleted === 1) {
        return 'background: #f5f7fa;'
      }
    },
    // 明细导出
    async excelMerchantDetail() {
      const { data: res } = await excelMerchant(this.query).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '商家明细-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="less" scoped>

.qrcodeBox {
  position: fixed;
  bottom: 100px;
  left: 18px;
  z-index: 99;
}
.box-card .el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    margin: 0;
    width: 33%;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
.el-input,
.el-date-picker,
.el-select {
  width: 160px !important;
}
.el-switch {
  margin-left: 10px;
}
.seachBtn {
  display: inline-block;
  margin-left: 20px;
}

.mer-dt {
  .el-form--inline .el-form-item {
    margin: 0 0 5px 0;
    width: 50%;
    .el-button {
      margin-left: 30px;
    }
    p {
      margin: 0;
    }
  }
  .el-input {
    width: 300px;
  }
}

.logo,
.bg {
  width: 100px;
  height: 100px;
}

.amap {
  width: 100%;
  height: 600px;
  .amapBox {
    float: left;
    width: 75%;
    height: 100%;
  }
  .subBox {
    float: right;
    width: 25%;
    h3 {
      font-size: 22px;
      margin-left: 20px;
    }
    p {
      margin: 0 30px 30px 30px;
    }
    .subBtn {
      text-align: center;
      button {
        width: 200px;
        height: 40px;
        outline: none;
        color: #fff;
        font-size: 20px;
        font-weight: 600;
        line-height: 40px;
        border: none;
        border-radius: 20px;
        background-color: orange;
        cursor: pointer;
      }
    }
  }
  .pantoBox {
    cursor: pointer;
    position: absolute;
    top: 580px;
    left: 50px;
    width: 60px;
    height: 60px;
    background: url('../../assets/images/dingwei.png') no-repeat;
  }
}
.numberingBox {
  cursor: pointer
}
.wallet {
  box-sizing: border-box;
  padding: 0 15px;
  .el-breadcrumb {
    font-size: 16px;
  }
  .topBox {
    margin-bottom: 200px;
    div {
      p {
        font-size: 20px;
        font-weight: 700;
        text-align: center;
      }
      .expand {
        .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          width: 50%;
        }
      }
    }
  }
  .bottom {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    p {
      margin-bottom: 0;
    }
    .charts {
      margin: 0 auto;
      width: 500px;
      height: 300px;
    }
  }
}

.modify {
  .el-input,
  .el-date-picker,
  .el-select {
    width: 240px !important;
  }
}

</style>
